export const INDEX = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    name: 'index',
    route: ''
};
export const LOGIN = {
    route: '/login',
    name: 'login'
};
export const RESET_PASSWORD = {
    route: '/resetpassword'
};
export const FORBIDDEN = {
    route: '/404'
};
export const DASHBOARD = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    route: '/dashboard',
    name: 'dashboard',
    desc: 'Portada',
};
export const USER = {
    profiles: ['MANAGEMENT'],
    desc: 'Usuarios',
    name: 'user',
    route: '/user'
};
export const USER_LIST = {
    profiles: ['MANAGEMENT'],
    desc: 'Lista de usuarios',
    name: 'user-list',
    route: '/user/list'
};
export const USER_NEW = {
    profiles: ['MANAGEMENT'],
    desc: 'Crear usuario',
    name: 'user-new',
    route: '/user/new'
};
export const USER_EDIT = {
    profiles: ['MANAGEMENT'],
    desc: 'Editar usuario',
    name: 'user-edit',
    route: '/user/:userId'
};
export const APP_ADMIN_USER = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Usuarios app admin',
    name: 'app-admin-user',
    route: '/app-admin-user'
};
export const APP_ADMIN_USER_LIST = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Lista de usuarios app admin',
    name: 'app-admin-user-list',
    route: '/app-admin-user/list'
};
export const APP_ADMIN_USER_NEW = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Crear usuario app admin',
    name: 'app-admin-user-new',
    route: '/app-admin-user/new'
};
export const APP_ADMIN_USER_EDIT = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Editar usuario app admin',
    name: 'app-admin-user-edit',
    route: '/app-admin-user/:userId'
};
export const HOTEL = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Hoteles',
    name: 'hotel',
    route: '/hotel'
};
export const HOTEL_LIST = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Lista de hoteles',
    name: 'hotel-list',
    route: '/hotel/list'
};
export const HOTEL_NEW = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Crear hotel',
    name: 'hotel-new',
    route: '/hotel/new'
};
export const HOTEL_EDIT = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Editar hotel',
    name: 'hotel-edit',
    route: '/hotel/:hotelId'
};
export const VEHICLE = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Vehículos',
    name: 'vehicle',
    route: '/vehicle'
};
export const VEHICLE_LIST = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Lista de vehículos',
    name: 'vehicle-list',
    route: '/vehicle/list'
};
export const VEHICLE_NEW = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Crear vehículo',
    name: 'vehicle-new',
    route: '/vehicle/new'
};
export const VEHICLE_EDIT = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE'],
    desc: 'Editar vehículo',
    name: 'vehicle-edit',
    route: '/vehicle/:vehicleId'
};
export const GUEST = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    desc: 'Huéspedes',
    name: 'guest',
    route: '/guest'
};
export const GUEST_LIST = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    desc: 'Lista de huéspedes',
    name: 'guest-list',
    route: '/guest/list'
};
export const GUEST_NEW = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    desc: 'Crear huésped',
    name: 'guest-new',
    route: '/guest/new'
};
export const GUEST_EDIT = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    desc: 'Editar huésped',
    name: 'guest-edit',
    route: '/guest/:guestId'
};
export const PROFILE = {
    profiles: ['MANAGEMENT', 'CUSTOMER_SERVICE', 'HOTEL'],
    desc: 'Perfil',
    name: 'profile',
    route: '/profile'
};

export const CONFIG_PRICING = {
    profiles: ['MANAGEMENT'],
    desc: 'Precios',
    name: 'config-pricing',
    route: '/config/pricing'
};




// WEBPACK FOOTER //
// ./src/router/routes.js